'use client';

import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { useCountUp } from '@/hooks/useCountUp';
import { cn } from '@/lib/utils';

interface AnimatedCounterProps {
  value: number;
  suffix?: string;
  label: string;
  className?: string;
}

export function AnimatedCounter({
  value,
  suffix = '',
  label,
  className,
}: AnimatedCounterProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });
  const count = useCountUp(value, 2000, isInView);

  return (
    <div ref={ref} className={cn('text-center', className)}>
      <div className="text-title text-4xl md:text-5xl lg:text-6xl text-zibarit-bone">
        {count}
        {suffix}
      </div>
      <p className="text-body text-sm text-zibarit-marron-secundario mt-2">{label}</p>
    </div>
  );
}
